import TabBar from '../../../component/tab-bar/tab-bar';
import React, { useState, useEffect } from 'react';
import SettingsBranchesTab from './branches/settings-branches-tab';
import { SettingsBranchesBuildingsTab } from './branches/buildings/settings-branches-buildings-tab';
import { observer } from 'mobx-react-lite';
import { SettingsBranchesBuildingsClasses } from './branches/buildings/classes/settings-branches-buildings-classes';
import { ClassAttributes } from './attributes/class-attributes';
import { useLocation } from 'react-router-dom';
import { SettingsBuildings } from './buildings/settings-buildings';

const tabs = ['שלוחות', 'הגדרת תכולות כיתה', 'מבנים וכיתות'];

const SettingsBranchesPage = observer(() => {
  const [selectedIndex, setSelectedIndex] = useState(0);
  const location = useLocation();

  useEffect(() => {
    // Update selected index based on the current route
    if (location.pathname.includes('/branch-and-classes')) {
      setSelectedIndex(0);
    }
  }, [location.pathname]);

  const onTabSelected = (index: number) => {
    setSelectedIndex(index);
  };

  const isBuildingClassRoute = () => {
    const path = location.pathname;
    // Using regex to match the pattern with any number as buildingId
    const pattern = /^\/settings\/buildings\/\d+\/classes$/;
    return pattern.test(path);
  };

  const extractBuildingId = () => {
    const path = location.pathname;
    // Using regex with a capture group to extract the buildingId
    const match = path.match(/^\/settings\/buildings\/(\d+)\/classes$/);

    // If there's a match, return the captured group (buildingId)
    // Otherwise return null
    return match ? match[1] : undefined;
  };

  const renderContent = () => {
    const path = location.pathname;

    if (path.includes('/buildings/') && path.includes('/classes')) {
      return <SettingsBranchesBuildingsClasses />;
    } else if (path.includes('/buildings')) {
      return <SettingsBranchesBuildingsTab />;
    } else if (path.includes('/branches')) {
      return <SettingsBranchesTab />;
    } else {
      return <SettingsBranchesTab />;
    }
  };

  const renderSettingsBuildings = () => {
    if (isBuildingClassRoute()) {
      const buildingId = extractBuildingId();
      return <SettingsBuildings buildingId={Number(buildingId)} />;
    }
    return <SettingsBuildings />;
  };

  const tabsElement = [
    renderContent(),
    <ClassAttributes />,
    renderSettingsBuildings(),
  ];

  return (
    <div>
      <div className={'studies-settings-root'}>
        <div style={{ width: '100%' }} className={'studies-settings-body-page'}>
          <div className={'studies-settings-title'}>
            הגדרות מערכת - כתות ושלוחות
          </div>

          <TabBar
            tabs={tabs}
            onClick={(index) => {
              onTabSelected(index);
            }}
          ></TabBar>

          {/*{selectedIndex === 0 ? renderContent() : <ClassAttributes />}*/}
          {tabsElement[selectedIndex]}
        </div>
      </div>
    </div>
  );
});

export default SettingsBranchesPage;
